module.exports = __webpack_public_path__ + "img/nextStep2.530bbbba.png";